<template>
    <div>
        <el-form ref="form" class="owner-form" :model="locationInfo" label-position="top">
            <h2 class="section-title">Main contact</h2>
            <div class="form-grid">
                <el-form-item label="First name">
                    <el-input v-model="locationInfo.firstName"></el-input>
                </el-form-item>

                <el-form-item label="Last name">
                    <el-input v-model="locationInfo.lastName"></el-input>
                </el-form-item>

                <el-form-item label="First point of contact">
                    <el-radio-group v-model="locationInfo.firstContact" size="medium">
                        <el-radio-button :label="true">Yes</el-radio-button>
                        <el-radio-button :label="false">No</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Position">
                    <el-radio-group v-model="locationInfo.position" size="medium">
                        <el-radio-button label="Owner"></el-radio-button>
                        <el-radio-button label="Manager"></el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Phone number">
                    <el-input v-model="locationInfo.phoneNumber"></el-input>
                </el-form-item>

                <el-form-item label="Alternate phone number">
                    <el-input v-model="locationInfo.alternateNumber"></el-input>
                </el-form-item>

                <el-form-item label="Email">
                    <el-input v-model="locationInfo.email"></el-input>
                </el-form-item>
            </div>

            <h2 class="section-title">Alternative contact</h2>
            <div class="form-grid">
                <el-form-item label="First name">
                    <el-input v-model="locationInfo.alternativeFirstName"></el-input>
                </el-form-item>

                <el-form-item label="Last name">
                    <el-input v-model="locationInfo.alternativeLastName"></el-input>
                </el-form-item>

                <el-form-item label="Phone number">
                    <el-input v-model="locationInfo.alternativePhoneNumber"></el-input>
                </el-form-item>

                <el-form-item label="Alternative number">
                    <el-input v-model="locationInfo.alternativeAlternatePhoneNumber"></el-input>
                </el-form-item>

                <el-form-item label="Email">
                    <el-input v-model="locationInfo.alternativeEmail"></el-input>
                </el-form-item>
            </div>

            <div class="form-actions">
                <el-button type="primary" @click="onSubmit">Save</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ['location'],
        data() {
            return {
                locationInfo: '',
            }
        },
        methods: {

            onSubmit() {

                this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}`,
                    this.locationInfo,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {

                        console.log(response.data);

                        this.$notify({
                            title: 'Success',
                            message: 'Location updated.',
                            type: 'success'
                        });


                    })
                    .catch(error => {
                        console.log(error);

                    });

            },

        },


        beforeMount() {

            //HERE WE NEED TO CHECK IF IT COMES FROM A PROP OR THE URL.

            if (!this.location) {

                console.log('LOCATION DOESNT EXIST');

                // We have to do find by ref because we dont have access to location ID at this point
                this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/locations/findbyref/${this.$route.params.locationRef}`,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {
                        this.locationInfo = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });


            } else {

                this.locationInfo = this.location;

            }

        },
    }
</script>

<style scoped>
    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 40px;
        max-width: 1040px;
    }

    .form-grid >>> .el-form-item__content > .el-input {
        max-width: none;
    }

    @media (max-width: 900px) {
        .form-grid {
            grid-template-columns: minmax(0, 1fr);
        }
    }
</style>



// WEBPACK FOOTER //
// src/locations/OwnerInformation.vue